<template>
    <div>
        <DashboardLayout>
            <template #summary>
                <SummaryStatCard
                    v-for="card in summaryCards"
                    :key="card.label"
                    :label="card.label"
                    :value="card.value"
                    :tone="card.tone"
                />
            </template>
            <template #default>
                <simpleLayout v-if="true" :items_count="5">
                    <template #buttons>
                        <button type="button" class="btn btn-success mb-2 mr-2" @click="addClient"><i class="mdi mdi-plus mr-1"> </i> Add Client</button>
                        <button type="button" class="btn btn-success mb-2 mr-2" @click="exportToExcel('clientsTable')">
                            <i class="mdi mdi-file-excel mr-1"></i> Export to Excel
                        </button>
                    </template>
                    <template #table>
                        <clientsTable />
                    </template>
                </simpleLayout>
            </template>
        </DashboardLayout>
        <clientModal v-if="show_modal" />
        <!-- made false -->
        <div v-if="false">
            <p>jip"selected_client_id</p>
            <clientDetails />
        </div>
    </div>
</template>

<script>
import simpleLayout from "@/components/layout-templates/simple-layout.vue";
import clientsTable from "./clientsTable.vue";
import clientDetails from "./clientDetails";
import clientModal from "./clientModal.vue";
import DashboardLayout from "@/components/shared/DashboardLayout.vue";
import SummaryStatCard from "@/components/shared/SummaryStatCard.vue";
import _ from "lodash";

import { clientMethods, clientComputed } from "@/state/helpers";

export default {
    //eslint-disable-next-line
    components: { simpleLayout, clientsTable, clientDetails, clientModal, DashboardLayout, SummaryStatCard },
    data: () => ({
        show_modal: false,
    }),
    computed: {
        ...clientComputed,
        hasClientSelected() {
            return this.selected_client_id != -1;
        },
        // Client-base summary cards above the Webix list, derived client-side from the
        // already-loaded clients[] (loaded by clientsTable's own mounted -> getClients).
        // Returns [] until the list loads so the row doesn't flash zeroes (no col-* wrappers:
        // DashboardLayout owns the grid). All neutral — no client-base metric is "attention-worthy".
        summaryCards() {
            const clients = this.clients || [];
            if (!clients.length) {
                return [];
            }
            const byType = { stockist: 0, reseller: 0, individual: 0 };
            for (let i = 0; i < clients.length; i++) {
                const type = String(clients[i].type || "").toLowerCase();
                if (byType[type] !== undefined) {
                    byType[type]++;
                }
            }
            return [
                { label: "Total clients", value: clients.length, tone: "neutral" },
                { label: "Stockists", value: byType.stockist, tone: "neutral" },
                { label: "Resellers", value: byType.reseller, tone: "neutral" },
                { label: "Individuals", value: byType.individual, tone: "neutral" },
            ];
        },
    },
    methods: {
        ...clientMethods,
        exportToExcel(id) {
            /* eslint-disable */
            return webix.toExcel($$(id), {
                ignore: { actions: true },
                filename: _.uniqueId("clientsExport_"), // for filename
                name: "Clients", // for sheet name
            });
            /* eslint-enable */
        },
        addClient() {
            this.show_modal = true;
            this.$nextTick(() => {
                this.$bvModal.show("clientModal");
                this.$root.$once("bv::modal::hidden", (event) => {
                    if (event.type == "hidden" && event.componentId == "clientModal") {
                        this.show_modal = false;
                    }
                });
            });
        },
    },
    mounted() {
        //ensures if user nvaigated to another page that the id reset, else clientDetailsPage will be rendered
        this.setSelectedClientId(-1);
    },
};
</script>

<style lang="scss" scoped></style>
